import { Location } from '@angular/common';
import { Component, computed, OnDestroy, OnInit, Signal, signal, WritableSignal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { DropdownDirective } from 'src/app/directives/dropdown.directive';
import { UrlParams } from 'src/app/models/enums/Route.enum';
import { Video } from 'src/app/models/types/Product/Product.type';
import { AddOn } from 'src/app/models/types/Rule/Rule.type';
import { RulesService } from 'src/app/services/api/rules.service';
import { SharedService } from 'src/app/services/shared.service';
import { VideoComponent } from '../product-page/video/video.component';

@Component({
  selector: 'app-eternal-page',
  imports: [TranslateModule, VideoComponent, DropdownDirective],
  templateUrl: './eternal-page.component.html',
  styleUrl: './eternal-page.component.scss'
})
export class EternalPageComponent implements OnInit, OnDestroy {

  private _addOn: WritableSignal<AddOn | null> = signal(null);
  public addOn: Signal<AddOn | null> = computed(() => this._addOn());

  public title: WritableSignal<string> = signal('');

  public video: Signal<Video | undefined> = computed(() => {
    let mediaVideo = this.addOn()?.mediaVideo;
    if (mediaVideo) {
      return mediaVideo[0]
    }
    return undefined;
  });

  public pdfs: Signal<string[]> = computed(() => {
    return this.addOn()?.mediaPdf?.map(media => media.url) || []
  })

  private readonly _destroying$ = new Subject<void>();

  constructor(
    private readonly location: Location,
    private readonly route: ActivatedRoute,
    private readonly rulesService: RulesService,
    public readonly sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.route.paramMap
      .pipe(takeUntil(this._destroying$))
      .subscribe((params) => {
        let categoryId = params.get(UrlParams.Category);
        if (categoryId) {
          let category = this.rulesService.rulesMap.get(Number.parseInt(categoryId));
          this.title.set(category?.name || 'COLLECTION');
          let addOn = this.rulesService.getAddOn(Number.parseInt(categoryId));
          this._addOn.set(addOn);
        }
      });
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  handleGoBack() {
    this.location.back();
  }

}
